export const API_COMPANIES = "companies";
export const API_BRANCHES = "branches";
export const API_USERS = "users";
export const API_LICENSES = "licenses";
export const API_MOBILE_CONNECTION = "mobile";
export const API_MOBILE_CONNECTION_TEST = "testconnection"
export const API_GET_AUTH_TOKEN = "authenticate";
export const API_FILES = "image";
export const API_PROJECT_TYPE = "project/type";
export const API_APPOINTMENTS_SERVER_TASKS = "api/servertasks";
export const API_APPOINTMENTS_HOOKS = "api/v1/hooks";
export const API_APPOINTMENTS_MOBILE_CONNECTIONS = "mobile";
export const API_MOBILE_SERVER_TASKS = "api/servertasks";
export const API_MOBILE_PROVIDERS = "api/v1/carriers";
export const API_MS_SURVEY_TEMPLATES = "templates";

export const LOGIN = "/";
export const SUPPORT_LOGGERS = "support/loggers"
export const SUPPORT_ACTIVE_LOGS = "support/activeLogs"
export const SUPPORT_ALL_LOGS = "support/allLogs"
export const SUPPORT_LOGS = "support/logs"